import { ConfirmDialogData } from 'app/components/common/confirm-dialog/confirm-dialog.component';
import { ROW_DENIED } from 'app/services/template-view.service';

// Snackbar durations shared by the Manage Views dialogs
export const TOAST_SHORT = 3000;   // success confirmations
export const TOAST_LONG = 4000;    // errors / denials
export const TOAST_XLONG = 5000;   // partial failures the user should read

/** The one delete confirmation, used by both dialogs. */
export function deleteViewConfirm(name: string): ConfirmDialogData {
  return {
    title: `Delete “${name}”?`,
    message: "This permanently deletes the view for everyone it's shared with.",
    confirmText: 'Delete',
    destructive: true
  };
}

/** Message for a failed proc row: permission denial vs. gone/expired. */
export function errorRowMessage(row: any, deniedMsg: string): string {
  return row && row.templateViewID === ROW_DENIED
    ? deniedMsg
    : 'That view is no longer available — it may have been deleted. Please close and reopen Manage Views.';
}
